<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">{{ tituloModal }}</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- contenido -->
        <ValidationObserver ref="form_datos">
          <v-card class="mx-auto">
            <v-card-text class="text--primary px-8">
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Nombre" rules="required">
                    <v-text-field
                      type="text"
                      v-model="objDatos.nombres"
                      label="Nombre"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Apellidos" rules="required">
                    <v-text-field
                      v-model="objDatos.apellidos"
                      label="Apellidos"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider
                    name="# Identificación"
                    rules="required|integer"
                  >
                    <v-text-field
                      type="number"
                      v-model="objDatos.identificacion"
                      label="# Identificación"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <ValidationProvider name="Teléfono" rules="required|integer">
                    <v-text-field
                      v-model="objDatos.telefono"
                      label="Teléfono"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="8">
                  <ValidationProvider name="Email" rules="required|email">
                    <v-text-field
                      v-model="objDatos.email"
                      label="Email"
                      type="email"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Cargo" rules="required">
                    <v-select
                      v-model="objDatos.cargo"
                      :items="cargo"
                      item-text="cargo"
                      item-value="value"
                      label="Cargo"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <ValidationProvider name="Area" rules="required">
                    <v-select
                      :disabled="id && logueado.cargo !== 'Administrador'"
                      v-model="objDatos.area"
                      :items="areas"
                      item-text="nombre"
                      item-value="value"
                      label="Area"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col v-if="!this.id" cols="12" sm="6" md="5">
                  <ValidationProvider name="Contraseña" rules="required|min:6">
                    <v-text-field
                      v-model="objDatos.password"
                      :type="mostrarClave ? 'text' : 'password'"
                      label="Contraseña"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                      :append-icon="mostrarClave ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="mostrarClave = !mostrarClave"
                      prepend-icon="mdi-key"
                    ></v-text-field>
                  </ValidationProvider>
                  <div class="v-text-field__details" v-if="validar.length">
                    <div
                      class="v-messages theme--light error--text"
                      role="alert"
                    >
                      <div class="v-messages__wrapper">
                        <div
                          class="v-messages__message"
                          v-for="value in validar"
                          :key="value"
                        >
                          {{ value }}
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col v-if="!this.id" cols="12" sm="6" md="5">
                  <ValidationProvider
                    name="Confirmar Contraseña"
                    rules="required|min:6"
                  >
                    <v-text-field
                      v-model="objDatos.passwordConfirmar"
                      :type="mostrarClave ? 'text' : 'password'"
                      label="Confirmar Contraseña"
                      slot-scope="{ errors, valid }"
                      :error-messages="errors"
                      :success="valid"
                      required
                      :append-icon="mostrarClave ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="mostrarClave = !mostrarClave"
                      prepend-icon="mdi-key"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </ValidationObserver>

        <!-- fin contenido -->
        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark> Guardar </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { db } from "../../firebase";
export default {
  name: "ModalUsuario",
  data: () => ({
    objDatos: {
      disponibilidad: "",
    },
    dialog: true,
    cargo: [],
    areas: [],
    collection: "usuarios",
    validar: [],
    mostrarClave: false,
  }),
  props: {
    showModal: { type: Boolean, default: false },
    id: { type: String },
    condicion: { type: String },
    consulta: { type: Array },
  },
  computed: {
    ...mapState(["logueado"]),
    tituloModal(props) {
      return props.id ? "ACTUALIZAR" : "AGREGAR";
    },
  },
  async created() {
    await this.getData();
    await this.roles();
    await this.getAreas();
  },
  methods: {
    async getData() {
      try {
        if (this.id) {
          const datos = await db.collection(this.collection).doc(this.id).get();
          this.objDatos = datos.data();
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async roles() {
      try {
        const roles = await db
          .collection("cargos")
          .where("cargo", this.condicion, this.consulta)
          .get();
        if (roles.docs.length > 0) {
          const objRoles = roles.docs.map((e) => {
            return e.data();
          });

          objRoles.sort((a, b) => {
            return a.cargo - b.cargo;
          });
          this.cargo = objRoles;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAreas() {
      try {
        const areas = await db
          .collection("area")
          .where("estado", "==", true)
          .get();
        if (areas.docs.length > 0) {
          const objAreas = areas.docs.map((e) => {
            return e.data();
          });

          objAreas.sort((a, b) => {
            return a.cargo - b.cargo;
          });
          this.areas = objAreas;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async save() {
      this.validar = [];
      const regex = [];
      regex.push("[A-Z]"); // For Uppercase Alphabet
      regex.push("[a-z]"); // For Lowercase Alphabet
      regex.push("[0-9]"); // For Numeric Digits
      regex.push("[$@$!%*#?&]"); // For Special Characters

      const validar = await this.$refs.form_datos.validate();
      if (!validar) return false;
      try {
        this.objDatos.duracion_sesion = 15;
        this.objDatos.estado = true;
        this.objDatos.disponibilidad = "";
        this.objDatos.nombres = this.objDatos.nombres.toUpperCase().trim();
        this.objDatos.apellidos = this.objDatos.apellidos.toUpperCase().trim();
        if (!this.id) {
          // Guardar
          // Validation for each Regular Expression
          for (let i = 0; i < regex.length; i++) {
            if (!new RegExp(regex[i]).test(this.objDatos.password)) {
              if (i === 0)
                this.validar.push(
                  "Por lo menos debe contener una letra en mayúscula"
                );
              if (i === 1)
                this.validar.push(
                  "Por lo menos debe contener una letra en minúscula"
                );
              if (i === 2)
                this.validar.push("Por lo menos debe contener un numero");
              if (i === 3)
                this.validar.push(
                  "Por lo menos debe contener un carácter especial"
                );
              return;
            }
          }
          if (this.objDatos.password != this.objDatos.passwordConfirmar) {
            this.validar.push("Las contraseñas no coinciden");
            return;
          }
          this.objDatos.creado = Date.now();
          const headers = new Headers();
          headers.append("Content-Type", "application/json");
          const body = JSON.stringify({
            email: this.objDatos.email,
            emailVerified: false,
            phoneNumber: "",
            password: this.objDatos.password,
            displayName: "",
            photoURL: "",
          });
          const requestOptions = {
            method: "POST",
            headers,
            body,
            redirect: "follow",
          };
          const userCreado = await fetch(
            `${process.env.VUE_APP_CLOUDFUNCTIONURL}/crearUsuario`,
            requestOptions
          );
          const objUsuario = await userCreado.json();
          const { uid } = objUsuario.usu;
          if (uid) {
            delete this.objDatos.password; // eliminamos la propiedad password para no registrarla en la collections de usuarios
            delete this.objDatos.passwordConfirmar; // eliminamos la propiedad password para no registrarla en la collections de usuarios
            this.objDatos.uiid = uid;
            this.objDatos.login = "";
            this.objDatos.ip = "";
            await db.collection(this.collection).add(this.objDatos);
            this.$swal({
              icon: "success",
              title: "Operación Exitosa",
              text: "",
            });
            this.cerrarModal();
            this.$emit("actualizar");
          }
        } else {
          // Actualizar
          this.objDatos.modificacion = Date.now();
          await db
            .collection(this.collection)
            .doc(this.id)
            .update(this.objDatos);
          // actualizar email
          const headers = new Headers();
          headers.append("Content-Type", "application/json");
          const body = JSON.stringify({
            email: this.objDatos.email,
            uid: this.objDatos.uiid,
          });
          const requestOptions = {
            method: "PUT",
            headers,
            body,
            redirect: "follow",
          };
          await fetch(
            `${process.env.VUE_APP_CLOUDFUNCTIONURL}/editarUsuario`,
            requestOptions
          );
          this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
          this.cerrarModal();
          this.$emit("actualizar");
        }
      } catch (error) {
        console.log(error);
        this.handleError(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
      this.objDatos = {};
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>
